import { AuthRoute } from '@/system-modules/auth/v1/api/AuthRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { PinParams } from '@/system-modules/auth/v1/api/v1/auth/Pin/Dto/PinParams'
import { PinRequest } from '@/contracts/system-modules/auth/dto/pin/PinRequest'
import { v4 as uuidv4 } from 'uuid'

export const OFFLINE_PIN = '1234'
export const OFFLINE_REQUEST = '0ff11e00-0000-4000-8000-00000000c0de'

export class PinRoute extends AuthRoute<PinParams, PinRequest> {
  type(): EnumRouteType {
    return EnumRouteType.POST
  }

  url(): string {
    return '/api/system/v1/auth/pin'
  }

  /** Без сервера ответ тоже одной формы; подтверждается только OFFLINE_PIN */
  offline(params: PinParams): Promise<ApiResponse<PinRequest>> {
    const request = params.pin === OFFLINE_PIN ? OFFLINE_REQUEST : uuidv4()

    return Promise.resolve(new ApiResponse({ success: true, data: new PinRequest({ request }) }))
  }
}
